import React from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import Cookie from "js-cookie";
import translation from "../../shared/utils/translation";


const FooterSectionWrapper = styled.section`
  padding: 1rem 2rem;
  font-size: 14px;
    
`;

const Title = styled.div`
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ListItem = styled.li`
    margin-bottom: 0.3rem;

    a {
        color: inherit;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }
`;

function FooterSection() {
    const lang = Cookie.get("selectedLanguage") || "EN";

    return (
        <FooterSectionWrapper>
            <Title>{translation("common.termsTitle") || "Villkor"}</Title>
            <List>
                <ListItem>
                    <a href={`/static/docs/IML_${lang}.pdf`} target="_blank" rel="noopener noreferrer">
                        {translation("common.tos") || "Allmänna köpvillkor"} ↗
                    </a>
                </ListItem>
            </List>
        </FooterSectionWrapper>
    );
}

export default observer(FooterSection);
